import React from 'react';
import { Home, Plus, RefreshCw, Trash2, Users } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/card';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { TabsContent } from '../../../components/ui/tabs';

export const TahTemplateTab = ({ creatingTahItem, deletingTahItem, handleAddTahItem, handleDeleteTahItem, loadTahTemplate, loadingTahTemplate, newTahItemName, setNewTahItemName, tahTemplate }) => (
            <TabsContent value="tah-template">
              <Card>
                <CardHeader>
                  <div className="flex items-center gap-2">
                    <Home className="w-5 h-5 text-teal-600" />
                    <CardTitle>TAH (Therapy @Home) Template</CardTitle>
                  </div>
                  <CardDescription>
                    Configure the questions that appear when users enable TAH (Therapy @Home) on their tactical.
                    Users can enable TAH each month by clicking the checkbox in the Facility Overview section.
                    TAH data is automatically removed during monthly rollover - users must re-enable it each month.
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  {loadingTahTemplate ? (
                    <div className="text-center py-8 text-muted-foreground">
                      Loading TAH template...
                    </div>
                  ) : tahTemplate === null ? (
                    <div className="text-center py-8">
                      <Button onClick={loadTahTemplate}>
                        <RefreshCw className="w-4 h-4 mr-2" />
                        Load TAH Template
                      </Button>
                    </div>
                  ) : (
                    <div className="space-y-4">
                      {tahTemplate.length === 0 ? (
                        <div className="text-center py-6 text-muted-foreground bg-slate-50 rounded-lg border-2 border-dashed">
                          <Home className="w-8 h-8 mx-auto mb-2 opacity-50" />
                          <p>No TAH template items configured yet.</p>
                          <p className="text-xs">Add items below to define what questions appear in the TAH section.</p>
                        </div>
                      ) : (
                        tahTemplate.map((item, index) => (
                          <div key={item.id} className="flex items-center gap-3 p-3 bg-teal-50 border border-teal-200 rounded-lg">
                            <span className="text-sm font-medium text-teal-600 w-6">
                              {index + 1}.
                            </span>
                            <div className="flex-1">
                              <span className="text-sm font-medium">{item.name}</span>
                            </div>
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => handleDeleteTahItem(item.id)}
                              className="text-destructive hover:text-destructive"
                              disabled={deletingTahItem === item.id}
                            >
                              {deletingTahItem === item.id ? (
                                <div className="animate-spin h-4 w-4 border-2 border-destructive border-t-transparent rounded-full" />
                              ) : (
                                <Trash2 className="w-4 h-4" />
                              )}
                            </Button>
                          </div>
                        ))
                      )}
                      
                      <div className="pt-4 border-t mt-4">
                        <Label className="text-sm font-medium">Add New TAH Item</Label>
                        <div className="flex gap-2 mt-2">
                          <Input
                            value={newTahItemName}
                            onChange={(e) => setNewTahItemName(e.target.value)}
                            placeholder="Enter TAH question/category name..."
                            className="flex-1"
                            onKeyPress={(e) => e.key === 'Enter' && handleAddTahItem()}
                          />
                          <Button 
                            onClick={handleAddTahItem} 
                            disabled={creatingTahItem || !newTahItemName.trim()}
                          >
                            {creatingTahItem ? (
                              <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
                            ) : (
                              <>
                                <Plus className="w-4 h-4 mr-2" />
                                Add
                              </>
                            )}
                          </Button>
                        </div>
                        <p className="text-xs text-muted-foreground mt-2">
                          These items will appear when users enable TAH on their tactical.
                        </p>
                      </div>
                    </div>
                  )}
                </CardContent>
              </Card>
            </TabsContent>
);
